import React from 'react';

interface LoadingSpinnerProps {
  fullPage?: boolean;
  size?: 'sm' | 'md' | 'lg';
  /** No outer padding — for buttons / inline chrome. */
  inline?: boolean;
}

/**
 * Globalny zielony spinner zgodny z designem Solid Glass.
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  fullPage = false,
  size = 'md',
  inline = false,
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-16 w-16 border-4',
    lg: 'h-24 w-24 border-8',
  };

  if (fullPage) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/80 backdrop-blur-sm">
        <div className="relative">
          <div className={`${sizeClasses.md} rounded-full border-white/10`} />
          <div
            className={`${sizeClasses.md} absolute top-0 left-0 rounded-full border-t-green-400 border-r-transparent border-b-transparent border-l-transparent animate-spin`}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={inline ? 'inline-flex items-center justify-center shrink-0' : 'flex items-center justify-center p-4'}
      aria-hidden
    >
      <div className="relative">
        <div className={`${sizeClasses[size]} rounded-full border-white/10`} />
        <div
          className={`
            ${sizeClasses[size]}
            absolute top-0 left-0 rounded-full
            border-t-green-400 border-r-transparent border-b-transparent border-l-transparent
            animate-spin
          `}
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;
